export default "__VITE_ASSET__CovoS1jJ__"